///Dictionary to store Vehicle id mapping to Initial State of Charge
export interface ChargeDictionary {
  [key: number]: number;
}
export let chargeDictionary: ChargeDictionary = {};
